export default __webpack_public_path__ + "static/media/gg3.68f25821.jpeg";